import React, { useState, useEffect, useMemo, useCallback } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { components } from 'react-select';
import { isEmpty } from 'lodash';

import HelpBallon from '../../Intelligence/component/HelpBalloon/HelpBalloon';
import Select from '../../Select';
import Validation from './Validation';
import { getFields } from '../../../store/actions/rd-station';

const emptyField = {
  question: '',
  uuid: '',
  label: { default: '' },
  name: { default: '' },
  apiIdentifier: '',
  customField: false,
  validationRules: {},
  presentationType: '',
  dataType: '',
};

const RDStationInputSettings = (props) => {
  const { toggleAnswerHandler, item, answerHandlerOpen } = props;
  const bot = useSelector((state) => state?.bots?.bot);
  const fields = useSelector((state) => state?.rdStation?.fields);

  const [currentField, setCurrentField] = useState(null);
  const [selectedField, setSelectedField] = useState(null);
  const [fieldQuestion, setFieldQuestion] = useState('');

  const dispatch = useDispatch();

  useEffect(() => {
    if (!Array.isArray(fields) || (fields.length === 0 && bot)) {
      const botId = bot?._id;
      dispatch(getFields({ botId }));
    }
  }, []);

  useEffect(() => {
    if (item && item?.rdStationInput) {
      const { uuid, label, question } = item.rdStationInput;

      if (uuid && uuid !== '') {
        const newQuestion =
          typeof question === 'string' ? question : label?.default;
        setSelectedField({
          value: uuid,
          label: label?.default,
        });

        setCurrentField(item.rdStationInput);
        setFieldQuestion(newQuestion);
      } else {
        setSelectedField(null);
        setCurrentField(null);
        setFieldQuestion('');
      }
    }
  }, [item]);

  const onChangeSelectedField = useCallback(
    (option) => {
      const { doUpdateItem } = props;
      if (!option) {
        setSelectedField(null);
        doUpdateItem({ rdStationInput: emptyField });
        setCurrentField(emptyField);
        return;
      }

      const newField = fields.find(({ uuid }) => uuid === option?.value);

      if (!newField) {
        setSelectedField(null);
        doUpdateItem({ rdStationInput: emptyField });
        setCurrentField(emptyField);
        return;
      }

      const question = newField?.label?.default;
      setSelectedField(option);

      if (newField.presentationType === 'CHECK_BOX') {
        newField.validationRules = {
          valid_options: [
            { value: 'true', label: { 'pt-BR': 'Sim', default: 'Sim' } },
            { value: 'false', label: { 'pt-BR': 'Não', default: 'Não' } },
          ],
        };
      }

      setFieldQuestion({ ...newField, question });
      doUpdateItem({
        rdStationInput: { ...newField, question },
      });
    },
    [fields]
  );

  const onChangeQuestionTextArea = useCallback(
    (event) => {
      const { doUpdateItem } = props;
      const { value } = event.target;
      const newRdStationInput = {
        ...currentField,
        question: value,
      };
      setFieldQuestion(value);
      doUpdateItem({ rdStationInput: newRdStationInput });
    },
    [fieldQuestion]
  );

  const fieldsOptions = useMemo(() => {
    if (!fields) {
      return [];
    }
    return fields.map(({ uuid, name, label }) => ({
      value: uuid,
      label: name?.default || label?.default,
    }));
  }, [fields]);

  const optionField = (optionProps) => {
    const { data } = optionProps;
    return (
      <components.Option {...optionProps}>
        <strong>{data.label}</strong>
      </components.Option>
    );
  };

  const renderFieldSelect = () => {
    if (!answerHandlerOpen) {
      return false;
    }

    return (
      <div style={{ marginTop: 5 }}>
        <Select
          className="pt-0 mb-2"
          label="Campo"
          options={fieldsOptions}
          value={selectedField}
          onChange={onChangeSelectedField}
          isClearable
          components={{ Option: optionField }}
        />
      </div>
    );
  };

  const renderValidationSelect = () => {
    if (!currentField || !isEmpty(currentField.validationRules)) {
      return false;
    }

    return (
      <>
        <p className="pointer handler-title">Adicione uma validação</p>
        <Validation {...props} useVariable={false} />
      </>
    );
  };

  const renderUseCustomValidation = () => {
    if (!currentField || isEmpty(currentField.validationRules)) {
      return false;
    }

    return (
      <div style={{ margin: 5 }}>
        <div className="mt-2">
          <label className="custom-control-label-font">
            validação da RD Station
          </label>
          <HelpBallon
            id="help-ballon-rd-station-validation"
            message="Será feito uma validação da informação com as regras que foram configuradas na plataforma RD Station para esse campo."
          />
        </div>
      </div>
    );
  };

  const renderLabelTextArea = () => {
    return (
      <div className="form-group error-message-input-group mb-2">
        <label>Label</label>
        <div>
          <textarea
            id="error-errorMessage"
            value={fieldQuestion || ''}
            onChange={onChangeQuestionTextArea}
          />
        </div>
      </div>
    );
  };

  return (
    <div>
      <div className="rd-station-input-settings-options-divider" />
      <p className="pointer handler-title" onClick={toggleAnswerHandler}>
        Selecione uma informação
        <img
          alt=""
          className={`seta-expander ${
            !answerHandlerOpen ? 'arrow-rotation' : ''
          }`}
          src="/assets/images/icons/seta_close.svg"
        />
      </p>
      {renderFieldSelect()}
      {selectedField && renderLabelTextArea()}
      {selectedField && renderValidationSelect()}
      {renderUseCustomValidation()}
    </div>
  );
};

export default RDStationInputSettings;
